export const US_COUNTRY_CODE = 'US';

// true -> always show
// false -> never show
// undefined/null -> show only for US
export const shouldShowCardZipCode = (showCardZipCode, countryCode) => {
	if (showCardZipCode === false) {
		return false;
	}

	if (showCardZipCode === true) {
		return true;
	}

	return String(countryCode || '').toUpperCase() === US_COUNTRY_CODE;
};
